<img
  [mat-dialog-close]
  class="close-icon"
  ngSrc="assets/img/icons/close.svg"
  alt=""
  height="16"
  width="16"
/>
<h2>{{ 'footer.language.title' | translate }}</h2>
<pac-language-badge
  *ngFor="let lang of languages"
  [language]="lang"
  (click)="setLanguage(lang)"
/>
